module.exports = __webpack_public_path__ + "img/ERP_swiperTab_bg6.f281f295.png";